
import Vue from "vue";
import SVGIcon from '@/components/svgIcon/index.vue'
import { faBackward, faBackwardStep, faForward, faForwardStep } from '@fortawesome/free-solid-svg-icons';

export default Vue.extend({
	props: {
		current: {
			type: Number,
			default: 1
		},
		pageSize: {
			type: Number,
			default: 10
		},
		total: {
			type: Number,
			default: 0
		},
		visibleNumber: {
			type: Number,
			default: 10
		}
	},
	components: {
		SVGIcon
	},
	model: {
		prop: 'current',
		event: 'pageChange'
	},
	methods: {
		handlePageChange(page: number) {
			if (page < 1) {
				page = 1
			}
			if (page > this.pageNumber) {
				page = this.pageNumber
			}
			page !== this.current && this.$emit('pageChange', page)
		}
	},
	computed: {
		//总页数
		pageNumber(): number {
			//向上取整
			return Math.ceil(this.total / this.pageSize)
		},
		//当前分页显示最小值
		minVisibleNumber(): number {
			//向下取整
			let res = this.current - Math.floor(this.visibleNumber / 2)
			if (res < 1) {
				res = 1
			}
			return res
		},
		maxVisbleNumber(): number {
			let res = this.current + Math.floor(this.visibleNumber / 2)
			if (res > this.pageNumber) {
				res = this.pageNumber
			}
			return res
		},
		pages(): number[] {
			const res: number[] = []
			for (let i = this.minVisibleNumber; i <= this.maxVisbleNumber; i++) {
				res.push(i)
			}
			return res
		},
		next: () => faForward,
		end: () => faForwardStep,
		before: () => faBackward,
		start: () => faBackwardStep
	}
})
